import React, { useCallback, useEffect, useState } from "react";
import { FaEnvelopeOpenText, FaPlus, FaSync, FaThLarge, FaTrash } from "react-icons/fa";
import { api, STATUS_CLS, STATUS_LABEL } from "./schreibenUtils";
import ThemenVerwaltung from "./ThemenVerwaltung";
import SchreibenAssistent from "./SchreibenAssistent";
import "../Tab6Vorgaenge.css";

const fmtDatum = (d) => (d ? new Date(d).toLocaleDateString("de-DE") : "—");

/* Weitere Vorgänge (Welle 90): Umzug, SEPA-Mandat, … — Vorgangsliste + Assistent.
   Läuft eingebettet im Tab „Vorgänge" (eingebettet=true blendet die Bausteinverwaltung aus,
   die hängt dort am Zahnrad-Button daneben). */
export default function Tab7Schreiben({ initialVorgang, eingebettet = false, onProzess }) {
  const [vorgaenge, setVorgaenge] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [fehler, setFehler] = useState("");
  const [laden, setLaden] = useState(false);
  const [themenOffen, setThemenOffen] = useState(false);
  const [assistent, setAssistent] = useState(initialVorgang ? Number(initialVorgang) : undefined);
  // assistent: undefined = zu, null = neuer Vorgang, Zahl = bestehender

  const reload = useCallback(async () => {
    setLaden(true);
    try {
      const d = await api(`?${statusFilter ? `status=${statusFilter}` : ""}`);
      setVorgaenge(d.vorgaenge || []);
      setFehler("");
    } catch (e) { setFehler(String(e.message || e)); }
    setLaden(false);
  }, [statusFilter]);
  useEffect(() => { reload(); }, [reload]);

  const loeschen = async (e, v) => {
    e.stopPropagation();
    if (!window.confirm(`Vorgang #${v.id} „${v.thema_name || ""}" löschen?\n(Dateien im Dropbox-Ordner bleiben liegen.)`)) return;
    try { await api(`/${v.id}`, "DELETE"); reload(); }
    catch (err) { setFehler(String(err.message || err)); }
  };

  return (
    <>
      <div className="me-table-header" style={{ marginBottom: 8 }}>
        <h3>Weitere Vorgänge (Umzug, SEPA, …) ({vorgaenge.length})</h3>
      </div>
      <div className="vg-kopf">
        <div className="vg-chips">
          <button className={`vg-chip ${statusFilter === "" ? "aktiv" : ""}`} onClick={() => setStatusFilter("")}>Alle</button>
          {Object.entries(STATUS_LABEL).map(([k, l]) => (
            <button key={k} className={`vg-chip ${statusFilter === k ? "aktiv" : ""}`}
                    onClick={() => setStatusFilter(k)}>{l}</button>
          ))}
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button className="me-btn me-btn-icon" title="Aktualisieren" onClick={reload}>
            <FaSync className={laden ? "spin" : ""} />
          </button>
          {!eingebettet && (
            <button className="me-btn me-btn-secondary me-btn-sm" onClick={() => setThemenOffen(true)}>
              <FaThLarge /> Textbausteine verwalten
            </button>
          )}
          <button className="me-btn me-btn-primary me-btn-sm" onClick={() => setAssistent(null)}>
            <FaPlus /> Neuer Vorgang
          </button>
        </div>
      </div>

      {fehler && <div className="me-status error">❌ {fehler}</div>}

      <div className="me-table-wrap">
        <table className="me-table">
          <thead>
            <tr>
              <th>#</th><th>Thema</th><th>Absender</th><th>Empfänger</th>
              <th>Status</th><th>Dokument</th><th>Angelegt</th><th></th>
            </tr>
          </thead>
          <tbody>
            {vorgaenge.length === 0 && !laden && (
              <tr><td colSpan={8} style={{ textAlign: "center", color: "#94a3b8", padding: 20 }}>
                Noch keine Vorgänge — oben „Neuer Vorgang" starten (z.B. Umzugsmitteilung, SEPA-Mandat).
              </td></tr>
            )}
            {vorgaenge.map((v) => (
              <tr key={v.id} style={{ cursor: "pointer" }} onClick={() => setAssistent(v.id)}>
                <td>{v.id}</td>
                <td><FaEnvelopeOpenText style={{ marginRight: 6, color: "#a5b4fc" }} />{v.thema_name || "—"}</td>
                <td>{v.absender_suchbegriff || "—"}</td>
                <td>{(() => {
                  const e = Array.isArray(v.empfaenger) ? v.empfaenger : (v.empfaenger ? [v.empfaenger] : []);
                  if (!e.length) return "—";
                  const erster = (e[0].adressblock || [])[0] || e[0].label || "—";
                  return e.length > 1 ? `${erster} +${e.length - 1} weitere` : erster;
                })()}</td>
                <td><span className={`me-badge ${STATUS_CLS[v.status] || "me-badge-none"}`}>{STATUS_LABEL[v.status] || v.status}</span></td>
                <td style={{ color: "#94a3b8" }}>{v.baustein_titel || "—"}</td>
                <td>{fmtDatum(v.erstellt_am)}</td>
                <td>
                  <button className="me-btn me-btn-icon me-btn-danger" title="Vorgang löschen"
                          onClick={(e) => loeschen(e, v)}><FaTrash /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {themenOffen && <ThemenVerwaltung onClose={() => { setThemenOffen(false); reload(); }} />}
      {assistent !== undefined && (
        <SchreibenAssistent vorgangId={assistent} onClose={() => { setAssistent(undefined); reload(); }}
          onProzess={onProzess ? (p) => { setAssistent(undefined); onProzess(p); } : undefined}
                            onChanged={reload} />
      )}
    </>
  );
}
